import brandTheme from '../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  background: {
    background: '#FAF8FF',
    padding: '30px 20px',
    minHeight: '100vh',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    '& .text-center': {
      textAlign: 'center',
    },
    '& .text-left': {
      textAlign: 'left',
    },
    '& h1': {
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '38px',
      width: '100%',
      textAlign: 'center',
    },
    '& h3': {
      fontSize: 18,
      margin: '0 auto 12px',
      maxWidth: 490,
    },
    '& .inputMarginStep3': {
      marginBottom: '16px',
    },
    '& .inputMargin': {
      marginBottom: '8px',
    },
    '& .content': {
      backgroundColor: 'white',
      padding: '64px 40px 40px',
      border: 'solid 1px #E2E2FC',
      borderRadius: 24,
      '&-inner': {
        maxWidth: 496,
        width: '100%',
        margin: '0 auto',
      },
      '&.has-large-padding': {
        padding: '64px 40px 40px',
        '@media screen and (max-width: 960px)': {
          padding: 20,
        },
      },
      '&.h-100': {
        minHeight: '100%',
      },
      '& .link': {
        fontSize: 16,
        textAlign: 'center',
        marginTop: '24px',
        '& div': {
          display: 'inline',
        },
      },
      '& .links': {
        color: '#F04D6B',
        fontSize: '16px',
        textDecoration: 'underline',
      },
      '& .buttonsContainer': {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      },
      '& .bold': {
        fontWeight: 500,
      },
      '& .error': {
        textAlign: 'center',
        color: '#FF0000',
        fontSize: '16px',
      },
      '& .buttonNext': {
        margin: '14px auto',
        padding: 0,
        borderRadius: 16,
        textTransform: 'none',
        width: '100%',
        maxWidth: 416,
        boxShadow: 'none',
        fontSize: 16,
        lineHeight: '40px',
        fontWeight: 700,
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        display: 'block',
        '&:not(:disabled)': {
          backgroundColor: colors.primary,
          '&:hover': {
            backgroundColor: 'white',
            color: colors.primary,
            boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.1)',
            transition:
              'background-color 0.4s ease, box-shadow 0.4s ease, color 0.4s ease',
          },
        },
      },
      '& .signUpButton': {
        margin: '16px 0px 0px',
        padding: 0,
        borderRadius: 4,
        textTransform: 'none',
        width: '100%',
        maxWidth: 496,
        boxShadow: 'none',
        fontSize: 16,
        lineHeight: '40px',
        fontWeight: 700,
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        display: 'block',
        '&:not(:disabled)': {
          backgroundColor: colors.primary,
          '&:hover': {
            backgroundColor: 'white',
            color: colors.primary,
            boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.1)',
            transition:
              'background-color 0.4s ease, box-shadow 0.4s ease, color 0.4s ease',
          },
        },
      },
    },
    '& .illustration': {
      maxWidth: '625px',
      width: '100%',
      height: 'auto',
      margin: '0 auto',
    },
  },
  wrap: {
    maxWidth: '1280px',
    margin: '0 auto',
    width: '100%',
  },
  svgWrap: {
    marginBottom: 30,
    display: 'inline-block',
    '& svg': {
      display: 'block',
    },
    '@media (max-width: 768px)': {
      marginBottom: 32,
      display: 'flex',
      justifyContent: 'center',
    },
  },
  bottomBlock: {
    textAlign: 'center',
    marginTop: 'auto',
    paddingTop: 30,
    width: '100%',
  },
}
